import React, { useState, useEffect } from "react";
import { View, Text, Image, TouchableOpacity, Dimensions } from "react-native";
import { CONSTANTS } from "../../utilities/Dimensions";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
  maxSize,
  minSize,
} from "rn-responsive-styles";
import { get, isEmpty } from "lodash";
import CImage from "../../common/CImage";
import * as RootNavigation from "../../utilities/RootNavigation";
import { getUserDetails } from "../../api/apiManager";
import { useLogin } from '../../context/loginProvider';
import CText from "../../common/CText";
import useStyles from "./UserDetails_Styles";

export default function UserDetails(props) {
  const styles = useStyles();
  const deviceSize = useDeviceSize();
  const { isLoggedIn, setIsLoggedIn } = useLogin();
  const [IMG_DATA,SET_IMG_DATA] = useState('')
  const [isShowSidebar, setIsShowSidebar] = useState(false);
  const [fullName, setFullName] = useState(false);
  let isSmallDevice =
    deviceSize === "small" || deviceSize === "extrasmall" ? true : false;
  let isTabView = deviceSize === "medium" ? true : false;

  const onclick = (index, screen) => {
    setIsShowSidebar(!isShowSidebar);
    props.setIsShowSidebar(isShowSidebar);
  };
 

  useEffect(() => {
    getProfileDetails()

  }, [])


  useEffect(() => {
    if(global.userProfileImg){
      SET_IMG_DATA(global.userProfileImg )
    }
  

  }, [global.userProfileImg])


  const getProfileDetails = () => {
    getUserDetails()
      .then((res) => {
        console.log("getUserDetails", res);
        setFullName(get(res, "fullName", ""));
      })
      .catch((err) => {
        console.log("<------------ error in profile data api ----------->");
        if (err?.message == "Invalid token specified") {
          setIsLoggedIn(false)
        }
      });
  };



  return props.isHeaderView ? (
    <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
      <View
        style={styles.contentWrapper}
      >
        {isSmallDevice ? (
          <TouchableOpacity onPress={() => (isSmallDevice ? onclick() : null)}>
            {isShowSidebar ? (
              <CImage.HamburgerMenuWhite></CImage.HamburgerMenuWhite>
            ) : (
              <CImage.HamburgerMenu></CImage.HamburgerMenu>
            )}
          </TouchableOpacity>
        ) : null}

        <View style={{ flexDirection: "row" }}>
          <View style={styles.defImg}>
            {IMG_DATA == "" || IMG_DATA == null ? (
              <CImage.DefaultProfilePic></CImage.DefaultProfilePic>
            ) : (
              <Image
                source={{ uri: `data:image/png;base64,${IMG_DATA}` }}
                style={{ height: "100%",width: "100%", borderRadius: 100, marginRight: 10, }}
              />
            )}
          </View>
          <View style={{ alignItems: "flex-start", justifyContent: "center" }}>
            <Text style={styles.globalName} > {fullName}</Text>
            <TouchableOpacity onPress={() => props.isLogout(true)} >
              <Text
                style={{
                  fontFamily: "Inter",
                  fontSize: isSmallDevice ? 10 : 15,
                  fontWeight: "normal",
                  fontStyle: "normal",
                  lineHeight: isSmallDevice ? 11 : 22,
                  letterSpacing: 0,
                  textAlign: "left",
                  color: "#ffffff",
                }}
              >
                {"Switch to "}
                <Text
                  style={{
                    fontFamily: "Inter",
                    fontSize: isSmallDevice ? 10 : 15,
                    fontWeight: "normal",
                    fontStyle: "normal",
                    lineHeight: isSmallDevice ? 11 : 22,
                    letterSpacing: 0,
                    textAlign: "left",
                    color: "#ffffff",
                    textDecorationLine: "underline"
                  }}
                >
                  {"other user"}
                </Text>
              </Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    
    </View>
  ) : (
    //body version
    <View style={styles.container}>
      <View style={{ flexDirection: "row" }}>
        {IMG_DATA == "" || IMG_DATA == null ? (
          <CImage.DefaultProfilePicSml></CImage.DefaultProfilePicSml>
        ) : (
          <Image
            source={{ uri: `data:image/png;base64,${IMG_DATA}` }}
            style={{ height: 60, width: 60, borderRadius: 80 }}
          />
        )}

        <View>
          <Text style={styles.globalName}> {fullName} </Text>
        </View>
      </View>

    </View>
  );
}
